import React, { Component } from 'react';
import {Auth} from 'aws-amplify';

class VerifyEmail extends Component {

  state = {
    inputVerificationCode: ''
  }

  componentDidMount() {
    this.handleResend();
  }

  render() {

    const {updateInput, handleSubmit, handleResend} = this;
    const {inputVerificationCode} = this.state;

    return (
      <div className="VerifyEmailPage">
        <h1>Enter the confirmation code sent to the provided email address.</h1>
        <label htmlFor="inputVerificationCode">Verification Code</label>
        <input id="inputVerificationCode" value={inputVerificationCode} onChange={updateInput}/>
        <button onClick={handleSubmit}>Submit</button>
        <button onClick={handleResend}>Resend Verification Code</button>
      </div>
    );
  }

  updateInput = e => {
    this.setState({[e.target.id]: e.target.value});
  }

  handleSubmit = () => {

    const {inputVerificationCode} = this.state;
    const {pushToLog, updateUserState} = this.props;

    if (inputVerificationCode === '') pushToLog('Verification code cannot be blank.');
    else {
      Auth.verifyCurrentUserAttributeSubmit('email', inputVerificationCode)
      .then(res => {
        pushToLog('Successfully logged in.');
        updateUserState({firstTimeUser: {}, challengeName: 'LOGGED_IN'});
      })
      .catch(err => {
        if (err.message === 'Invalid verification code provided, please try again.') pushToLog('Invalid verification code. Resend verification code and try again.');
        else {
          console.log(err);
        }
      });
    }

  }

  handleResend = () => {
    Auth.verifyCurrentUserAttribute('email')
    .then(res => {
    })
    .catch(err => {
      console.log(err);
    });
  }

}

export default VerifyEmail;


// WEBPACK FOOTER //
// ./src/components/content/user/userComponents/verifyEmail.js